import script from "./Complaints.vue?vue&type=script&lang=ts&setup=true"
export * from "./Complaints.vue?vue&type=script&lang=ts&setup=true"

import "./Complaints.vue?vue&type=style&index=0&id=0abb3aee&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0abb3aee"]])

export default __exports__